import * as S from '@components/layout//Layout.styled';
import Navbar from '@components/navbar';
import {Outlet} from 'react-router-dom';
import {ReactNode} from 'react';

interface LayoutProps {
    children?: ReactNode;
}

const Layout = ({children}: LayoutProps) => {
    return (
        <S.StyledContainer className="App">
            <Navbar />
            <S.StyledContent>
                <S.StyledChildren>{children || <Outlet />}</S.StyledChildren>
            </S.StyledContent>
        </S.StyledContainer>
    );
};

export default Layout;
